function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import HubspotContactForm from "segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form";
import Title from "segments/desktop/core-components/title/title";
import { MD } from "constants/sizes";
import { withGenericConfig } from "contexts/generic-config-context";
import { TEST_CONTACT_SALES_HUBSPOT_FORM_ID, PORTAL_ID, TEST_PORTAL_ID } from "client/services/hubspot-service/contact-form-config";
import classnames from "classnames";
import ContactSalesDetails from "./contact-sales-details";
import DefaultProps from "./default-props";
import { StyledHubspotWithBulletsSideBySideFormComponent } from "./hubspot-with-bullets-side-by-side-form-component.scss";
const isProduction = process.env.NODE_ENV === "production";
const HubspotWithBulletsSideBySideFormComponent = (props)=>{
    const { translate } = props;
    const { formId, source, overrideCampaignId, lastNameFirst, backgroundLayers, title, titleSize, benefits, logosTitle, logos, customerQuoteKey, formTitle, hideSupportStatement, contactSalesTestMode, alignToLogo, urlToRedirectAfterSubmission, dontRenderPostFormSubmit, splitForm } = props, restProps = _object_without_properties(props, [
        "formId",
        "source",
        "overrideCampaignId",
        "lastNameFirst",
        "backgroundLayers",
        "title",
        "titleSize",
        "benefits",
        "logosTitle",
        "logos",
        "customerQuoteKey",
        "formTitle",
        "hideSupportStatement",
        "contactSalesTestMode",
        "alignToLogo",
        "urlToRedirectAfterSubmission",
        "dontRenderPostFormSubmit",
        "splitForm"
    ]);
    let componentPortalId = PORTAL_ID;
    let componentFormId = formId;
    if (!isProduction || contactSalesTestMode) {
        componentPortalId = TEST_PORTAL_ID;
        componentFormId = TEST_CONTACT_SALES_HUBSPOT_FORM_ID;
    }
    const replaceTextComponentProps = {
        portalId: componentPortalId,
        formId: componentFormId,
        source,
        overrideCampaignId,
        lastNameFirst,
        backgroundLayers,
        formTitle,
        urlToRedirectAfterSubmission,
        dontRenderPostFormSubmit,
        splitForm
    };
    const replaceAssetComponentProps = {
        title,
        titleSize,
        benefits,
        logosTitle,
        logos,
        customerQuoteKey,
        hideSupportStatement
    };
    return /*#__PURE__*/ _jsxs(StyledHubspotWithBulletsSideBySideFormComponent, {
        className: classnames("hubspot-with-bullets-side-by-side-form-component", {
            "align-to-logo": alignToLogo
        }),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mobile-title",
                children: /*#__PURE__*/ _jsx(Title, {
                    title: translate(title),
                    titleSize: MD
                })
            }),
            /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread({
                replaceTextComponent: HubspotContactForm,
                replaceAssetComponent: ContactSalesDetails,
                replaceTextComponentProps: replaceTextComponentProps,
                replaceAssetComponentProps: replaceAssetComponentProps,
                alignToLogo: alignToLogo
            }, restProps))
        ]
    });
};
HubspotWithBulletsSideBySideFormComponent.defaultProps = DefaultProps;
export default withGenericConfig(HubspotWithBulletsSideBySideFormComponent);
